import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { DialogTitle } from '@/shared/components/ui/dialog';
import type { OperationDto } from '@/shared/types';
import { OperationDetailsContent } from './OperationDetailsContent';

type ModalProps = {
  operation: OperationDto;
  onClose: () => void;
  onStatusChange?: () => void;
};

export const OPERATION_DETAILS_DIALOG_CLASSNAME =
  'w-[calc(100%-1.6rem)] max-w-[34.4rem] sm:max-w-[34.4rem] max-h-[90dvh] p-0 gap-0 border-0 rounded-[1.6rem] bg-transparent shadow-none overflow-visible';

export function OperationHistoryDetailsModal({
  operation,
  onClose,
  onStatusChange,
}: ModalProps) {
  return (
    <>
      <VisuallyHidden>
        <DialogTitle>{operation.operationSubTypeName}</DialogTitle>
      </VisuallyHidden>

      <OperationDetailsContent
        operation={operation}
        onClose={onClose}
        onStatusChange={onStatusChange}
        className="max-h-[90dvh]"
      />
    </>
  );
}
